import { render, staticRenderFns } from "./GoodsDetailDialogContent.vue?vue&type=template&id=1425e198&scoped=true"
import script from "./GoodsDetailDialogContent.vue?vue&type=script&lang=js"
export * from "./GoodsDetailDialogContent.vue?vue&type=script&lang=js"
import style0 from "./GoodsDetailDialogContent.vue?vue&type=style&index=0&id=1425e198&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1425e198",
  null
  
)

export default component.exports